import { Link } from "react-router-dom";
import { ASSETS, COMPANY } from "@/lib/assets";

export default function Footer() {
  return (
    <footer className="bg-[#0A3B2C] text-white pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-12 w-12 rounded-lg overflow-hidden ring-1 ring-white/10 shadow-md bg-[#0A0F0C] flex items-center justify-center">
                <img src={ASSETS.logo} alt="faktor-direkt Logo" className="h-full w-full object-cover scale-110" data-testid="footer-logo" />
              </div>
              <div>
                <div className="text-lg font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>
                  faktor-direkt
                </div>
                <div className="text-xs text-white/60 tracking-wider uppercase">Struktur. Qualität. Vertrauen.</div>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed max-w-md">
              Direktvertrieb mit Struktur, Qualität und regionaler Stärke – für
              Stadtwerke, Gemeindewerke und regionale Energieversorger.
            </p>
          </div>

          {/* Kontakt */}
          <div>
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-4">
              Kontakt
            </div>
            <div className="space-y-2 text-sm text-white/80">
              <div>{COMPANY.street}</div>
              <div>{COMPANY.city}</div>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="block hover:text-[#10B981] transition-colors"
                data-testid="footer-phone"
              >
                {COMPANY.phone}
              </a>
              <a
                href={`mailto:${COMPANY.email}`}
                className="block hover:text-[#10B981] transition-colors"
                data-testid="footer-email"
              >
                {COMPANY.email}
              </a>
            </div>
          </div>

          {/* Rechtliches */}
          <div>
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-4">
              Rechtliches
            </div>
            <div className="space-y-2 text-sm">
              <FooterLink to="/impressum" testId="footer-link-impressum">Impressum</FooterLink>
              <FooterLink to="/datenschutz" testId="footer-link-datenschutz">Datenschutz</FooterLink>
              <FooterLink to="/cookie-einstellungen" testId="footer-link-cookies">Cookie-Einstellungen</FooterLink>
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-white/50">
            © {new Date().getFullYear()} faktor-direkt · Alle Rechte vorbehalten.
          </div>
          <div className="text-xs text-white/50">
            Geschäftsführer: {COMPANY.managingDirectors}
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, testId, children }) {
  return (
    <Link to={to} data-testid={testId} className="block text-white/80 hover:text-[#10B981] transition-colors">
      {children}
    </Link>
  );
}
